
<app-navbar></app-navbar>
<app-land-page></app-land-page>
<app-servicios></app-servicios>
<app-about></app-about>
<app-footer></app-footer>